// Exporta um arquivo Excel
export function exportExcel(data, fileName) {
  import('xlsx').then((xlsx) => {
    const worksheet = xlsx.utils.json_to_sheet(data)
    const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] }
    const excelBuffer = xlsx.write(workbook, {
      bookType: 'xlsx',
      type: 'array'
    })

    saveAsExcelFile(excelBuffer, fileName.toUpperCase())
  })
}

// Salva um arquivo Excel
function saveAsExcelFile(buffer, fileName) {
  import('file-saver').then((module) => {
    if (module && module.default) {
      let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
      let EXCEL_EXTENSION = '.xlsx'
      const data = new Blob([buffer], {
        type: EXCEL_TYPE
      })

      module.default.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION)
    }
  })
}

export function exportCSV(data, fileName) {
  import('file-saver').then((module) => {
    if (module && module.default) {
      const csvData = convertToCSV(data)
      const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' })

      module.default.saveAs(blob, fileName + '_export_' + new Date().getTime() + '.csv')
    }
  })
}

function convertToCSV(data) {
  const separator = ','
  const keys = Object.keys(data[0])

  const header = keys.join(separator) + '\n'

  const body = data
    .map((row) => {
      return keys.map((key) => row[key]).join(separator)
    })
    .join('\n')

  return header + body
}
